(function () {
    'use strict';

    angular.module('app.cultures', [
        // Angular modules
        'ngRoute'

        // Custom modules

        // 3rd Party Modules

    ]);
})();